module.exports = __webpack_public_path__ + "public/img/pingtaixitongyonghuhuoyueshu.3670eff7.png";